import React, { FC } from "react"
import { DefaultMoodIconSize } from "../../utils/constants"
import { MoodIconProps } from "../../utils/types"

const NorthStarIcon: FC<MoodIconProps> = ({
  x,
  y,
  backgroundColor,
  height = DefaultMoodIconSize,
  width = DefaultMoodIconSize,
}) => {
  return (
    <svg
      width={height}
      height={width}
      viewBox="0 0 22 22"
      fill="none"
      x={x}
      y={y}
    >
      <rect
        width={height}
        height={width}
        fill={!backgroundColor ? "white" : backgroundColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.31968 1.02921C9.61813 0.440883 10.2017 0.0563358 10.8523 0.00569879L11.0036 0C11.714 0.00162954 12.3643 0.401885 12.6812 1.03396L15.3157 6.2508L20.3004 6.74527C20.9711 6.81032 21.5528 7.22717 21.8301 7.83292L21.8886 7.97599C22.1366 8.66201 21.9628 9.42837 21.4444 9.94148L17.2948 14.0491L18.8326 19.6273C19.0144 20.2925 18.8147 20.9978 18.3238 21.4699L18.2054 21.5746C17.6335 22.0391 16.8424 22.1279 16.1787 21.8013L11 19.2364L5.82068 21.8045C5.20644 22.1082 4.47902 22.0536 3.91985 21.6715L3.79392 21.5775C3.21696 21.1082 2.9714 20.3432 3.16943 19.6281L4.70522 14.0491L0.55559 9.93859C0.074218 9.46211 -0.110018 8.76729 0.0647053 8.12119L0.111426 7.97307C0.358218 7.29047 0.97731 6.81241 1.69717 6.7426L6.6824 6.248L9.31968 1.02921ZM13.5672 7.77893L11 2.75L8.43469 7.77599C8.25073 8.13634 7.8934 8.37869 7.48735 8.41851L2.75 8.88273L6.75801 12.8107C7.03033 13.0776 7.15444 13.4552 7.09828 13.8247L7.06871 13.9627L5.59736 19.25L10.471 16.8602C10.763 16.7169 11.0996 16.6989 11.4028 16.8063L11.5305 16.8599L16.4055 19.2481L14.9333 13.963C14.8314 13.5972 14.914 13.2083 15.149 12.9155L15.2442 12.8104L19.25 8.88556L14.5146 8.42145C14.1536 8.38605 13.8312 8.19063 13.6348 7.89456L13.5672 7.77893Z"
        fill="#FFAC62"
      />
    </svg>
  )
}

export default NorthStarIcon
